import { render, staticRenderFns } from "./UserAnalytics.vue?vue&type=template&id=f8a119e8&"
import script from "./UserAnalytics.vue?vue&type=script&lang=js&"
export * from "./UserAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports